"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiMapFill16 = {
    paths: [
        {
            path: 'M6,8.119 L7.82938516,11.7768043 L10,10.039 L10,16.007 L6.00375009,13.8753335 L6,13.876 L6,8.119 Z M0,5.586 L2.96542918,9.82250995 L5,7.38 L5,14.221 L1.77635684e-15,15.9432919 L0,5.586 Z M13.0355709,7.61185566 L16.01,9.47 L16.0100002,13.8753335 L11,15.657 L11,9.239 L13.0355709,7.61185566 Z M6.00375009,0 L10,2.131 L10,8.759 L8.17061484,10.2231957 L6,5.882 L6,0.001 L6.00375009,0 Z M16.0100002,0 L16.01,8.292 L12.9644291,6.38814434 L11,7.959 L11,1.781 L16.0100002,0 Z M5,0.345 L5,5.818 L3.03457082,8.17749005 L0,3.842 L1.77635684e-15,2.06795836 L5,0.345 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Map',
    width: 17,
    height: 16,
};
var muiMapFill24 = {
    paths: [
        {
            path: 'M9.666,11.747 L13.3182807,17.0595325 L15,15.836 L15,24 L9.666,21.155 L9.666,11.747 Z M7.666,9.567 L7.666,21.259 L0,23.9 L0,10.758 L4.46144733,13.3978194 L7.666,9.567 Z M19.0348102,12.9020565 L24,15.957 L24,20.8 L17,23.289 L17,14.381 L19.0348102,12.9020565 Z M9.666,0.355 L15,3.2 L15,13.981 L13.6817193,14.9404675 L9.666,9.1 L9.666,0.355 Z M24,0 L24,14.196 L18.9651898,11.0979435 L17,12.526 L17,2.489 L24,0 Z M7.666,0.459 L7.666,7.23 L4.12859913,11.4581376 L0,9.015 L0,3.1 L7.666,0.459 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Map',
    width: 24,
    height: 24,
};
var muiMapFill = {
    base: muiMapFill16,
    smIcon: muiMapFill16,
    lgIcon: muiMapFill24,
};
exports.muiMapFill = muiMapFill;
//# sourceMappingURL=mapFill.js.map